import { useSelector } from 'react-redux';
import { PageTitle } from './PageTitle';
import { SidebarTabs } from './SidebarTabs';
import { ApplicationState } from '@/store';

export const Tabs = () => {
  const activeTab = useSelector(({ offersDashboard }: ApplicationState) => offersDashboard.currentTab);
  return (
    <>
      <PageTitle />
      <SidebarTabs activeTab={activeTab} />
    </>
  );
};
